import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  id: PropTypes.number.isRequired,
  isChecked: PropTypes.bool.isRequired,
  tableEntries: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  updateCheck: PropTypes.func.isRequired,
};

const FieldsetRow = ({ id, tableEntries, isChecked, updateCheck, type }) => (
  <tr key={id} className={isChecked ? 'selected' : ''}>
    <td>
      <input type="checkbox" id={id} checked={isChecked} onChange={evt => updateCheck(evt, type)} />
    </td>
    <td>{tableEntries.description}</td>
    <td>{tableEntries.name}</td>
    <td>{tableEntries.dataType}</td>
    <td>{tableEntries.length}</td>
  </tr>
);

FieldsetRow.propTypes = propTypes;

export default FieldsetRow;
